import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '@stockaid/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

interface Notice {
  title: string;
  list: string[];
}

interface Option {
  id: string;
  desc: string;
  required?: boolean;
}

@Component({
  selector: 'app-general-warning-modal',
  templateUrl: './general-warning-modal.component.html',
  styleUrls: ['./general-warning-modal.component.scss'],
})
export class GeneralWarningModalComponent
  extends BaseComponent
  implements AfterViewInit
{
  // HTML
  @Input() title: string = '';
  @Input() subtitle: string = '';

  // HTML
  @Input() content: string = '';

  // Array objects
  @Input() notices: Notice[] = [];

  // Define the form group if have any options.
  @Input() set setOptions(options: Option[]) {
    this._options = options;
    const formArray = this.confirmFormGroup.get('options') as FormArray;
    formArray.clear();

    if (options?.length) {
      options.forEach((option) => {
        const optionFormGroup = new FormGroup({
          id: new FormControl(option.id),
          confirm: new FormControl(
            false,
            option.required ? [Validators.requiredTrue] : []
          ),
        });

        formArray.push(optionFormGroup);
      });
    }
  }

  // Confirm text
  @Input() confirmText: string;
  @Input() contentComponent: any; // The component you pass
  @Input() contentComponentData: any; // Data for that component

  @ViewChild('dynamicContent', { read: ViewContainerRef })
  container: ViewContainerRef;

  _options: Option[] = [];

  confirmFormGroup: FormGroup = new FormGroup({ options: new FormArray([]) });

  constructor(
    public activeModal: NgbActiveModal,
    private componentFactoryResolver: ComponentFactoryResolver,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  get options(): FormArray {
    return this.confirmFormGroup.get('options') as FormArray;
  }

  ngAfterViewInit(): void {
    if (this.contentComponent) {
      this.container.clear();

      // Prepare factory (Angular 13- required)
      const factory = this.componentFactoryResolver.resolveComponentFactory(
        this.contentComponent
      );

      // Create component from factory
      const componentRef = this.container.createComponent(factory);

      // Pass data to the component
      if (this.contentComponentData) {
        Object.assign(componentRef.instance, this.contentComponentData);
      }

      this.cdr.detectChanges();
    }
  }

  public onCancel() {
    this.activeModal.dismiss();
  }

  public onConfirm() {
    this.activeModal.close({
      formValues: this.confirmFormGroup.value,
    });
  }
}
